module.exports = __webpack_public_path__ + "static/carousel-00002-2f376ccbd1ee894d87aae869f5b62a3a.jpg";